import "@fortawesome/fontawesome-free/js/all.min";
import VCalendar from 'v-calendar';
import Vue from "vue";
import App from "./App.vue";
import AppLogoSmallWhite from "./assets/Logo-small-white.vue";
import AppLogoSmall from "./assets/Logo-small.vue";
import ActionBtn from "./components/ActionBtn.vue";
import MenuCompany from "./components/MenuCompany.vue";
import ModalNotification from "./components/modais_sys/notificacoes/ModalNotification.vue";
import router from "./router/router";
import store from "./store/index";

import VueQrcode from "@chenfengyuan/vue-qrcode";
import "vue-loading-overlay/dist/vue-loading.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueSocket from "vue-socket.io";
import VueTheMask from "vue-the-mask";
import ErrorSection from "./assets/ErrorSection.vue";
import MemberItem from "./assets/MemberItem.vue";
import MemberItemNotify from "./assets/MemberItemNotify.vue";
import TRow from "./assets/TRow.vue";
import TRowDeps from "./assets/TRowDeps";
import TRowTotem from "./assets/TRowTotem.vue";
// Plugin Notification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
  position: "top-right",
  transition: "Vue-Toastification__bounce",
  closeOnClick: true,
  latestOnTop: true,
  maxToasts: 20,
  newestOnTop: true
});


// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
  screens: {
    tablet: '576px',
    laptop: '992px',
    desktop: '1200px',
  },                // ...other defaults
});


Vue.use(
  new VueSocket({
    debug: true,
    connection: "https://hermes-api.wtfapps.dev.br/"
  })
);

import "./filters";

// GLOBAL COMPONENTS
Vue.component(VueQrcode.name, VueQrcode);
Vue.component("AppLogoSmall", AppLogoSmall);
Vue.component("AppLogoSmallWhite", AppLogoSmallWhite);
Vue.component("ActionBtn", ActionBtn);
Vue.component("TRow", TRow);
Vue.component("TRowDeps", TRowDeps);
Vue.component("TRowTotem", TRowTotem);
Vue.component("MemberItem", MemberItem);
Vue.component("MemberItemNotify", MemberItemNotify);
Vue.component("v-select", vSelect);
Vue.component("ErrorSection", ErrorSection);
Vue.component("MenuCompany", MenuCompany);
Vue.component("ModalNotification", ModalNotification);

Vue.use(VueTheMask);

const app = new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});

//Service worker set up
const prod = process.env.NODE_ENV === "production";
//Production SW
const prodSW = prod;
//Development SW
const devSW = !prod;
//Test support for SW
if ("serviceWorker" in navigator) {
  //Production SW
  if (prodSW) {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => {
        console.log("Service Worker Registered!");
      })
      .catch(err => {
        console.error;
      });
    //Development SW
  } else if (devSW) {
    navigator.serviceWorker
      .register("/service-worker-dev.js")
      .then(() => {
        console.log("Dev Service Worker Registered!");
      })
      .catch(err => {
        console.log("Dev SW error:");
        console.error(err);
      });
  }
} else {
  console.log("Service worker not supported!");
}
